import * as types from "./types";

export const getCompanyUsersRequest = (payload) => ({
  type: types.GET_COMPANY_USERS_REQUEST,
  payload,
});

export const getCompanyUsersResponse = (payload) => ({
  type: types.GET_COMPANY_USERS_RESPONSE,
  payload,
});

export const createCompanyUserRequest = (payload) => ({
  type: types.CREATE_COMPANY_USER_REQUEST,
  payload,
});

export const createCompanyUserSuccess = (payload) => ({
  type: types.CREATE_COMPANY_USER_SUCCESS,
  payload,
});

export const createCompanyUserFailure = (payload) => ({
  type: types.CREATE_COMPANY_USER_FAILURE,
  payload,
});

export const getCompanyUserRequest = (payload) => ({
  type: types.GET_COMPANY_USER_REQUEST,
  payload,
});

export const getCompanyUserResponse = (payload) => ({
  type: types.GET_COMPANY_USER_RESPONSE,
  payload,
});

export const clearCompanyUser = () => ({
  type: types.CLEAR_COMPANY_USER,
});

export const updateCompanyUserRequest = (payload) => ({
  type: types.UPDATE_COMPANY_USER_REQUEST,
  payload,
});

export const updateCompanyUserSuccess = (payload) => ({
  type: types.UPDATE_COMPANY_USER_SUCCESS,
  payload,
});

export const updateCompanyUserFailure = (payload) => ({
  type: types.UPDATE_COMPANY_USER_FAILURE,
  payload,
});

export const deleteCompanyUserRequest = (payload) => ({
  type: types.DELETE_COMPANY_USER_REQUEST,
  payload,
});

export const deleteCompanyUserSuccess = (payload) => ({
  type: types.DELETE_COMPANY_USER_SUCCESS,
  payload,
});

export const deleteCompanyUserFailure = (payload) => ({
  type: types.DELETE_COMPANY_USER_FAILURE,
  payload,
});
